var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dom-template', {
    attrs: {
      "company": _vm.company
    }
  }, [(_vm.company.banner_url) ? _c('div', {
    staticClass: "company-banner",
    slot: "banner"
  }, [_c('editable-image', _vm._b({
    attrs: {
      "attribute": "banner",
      "width": "4000",
      "height": "1400",
      "recommendations": "Recommended dimensions: 2560 × 900"
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), (!_vm.company.banner_url) ? _c('div', {
    staticClass: "company-banner",
    slot: "banner"
  }, [_c('editable-image', _vm._b({
    attrs: {
      "kitten": true,
      "attribute": "banner",
      "width": "4000",
      "height": "1400",
      "recommendations": "Recommended dimensions: 2560 × 900"
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "sidebar"
  }, [_c('div', {
    staticClass: "company-name"
  }, [(_vm.company.logo_url || _vm.editable) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('editable-image', _vm._b({
    attrs: {
      "attribute": "logo",
      "width": "380",
      "height": "380",
      "removable": false,
      "recommendations": "Recommended dimensions: 380 x 380"
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), _c('company-name', {
    attrs: {
      "id": _vm.company.slug,
      "value": _vm.company.name,
      "editable": _vm.editable
    }
  }), _vm._v(" "), (_vm.company.locations.length > 0 && !_vm.company.remote) ? _c('p', {
    staticClass: "company-location"
  }, [_vm._v(_vm._s(_vm.company.locations[0].address))]) : _vm._e(), _vm._v(" "), (_vm.company.remote) ? _c('p', {
    staticClass: "company-location"
  }, [_vm._v("The Internet")]) : _vm._e(), _vm._v(" "), (this.company.motto || this.admin) ? _c('company-motto', {
    attrs: {
      "id": _vm.company.slug,
      "value": _vm.company.motto,
      "editable": _vm.editable
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('company-details', {
    attrs: {
      "company": _vm.company,
      "is-form": _vm.form,
      "editable": _vm.editable
    }
  })], 1), _vm._v(" "), _c('company-mission-statement', {
    attrs: {
      "id": _vm.company.slug,
      "value": _vm.company.mission_statement,
      "editable": _vm.editable
    },
    slot: "mission-statement"
  }), _vm._v(" "), (_vm.company.gif_url || _vm.form) ? _c('div', {
    staticClass: "company-gif",
    slot: "gif"
  }, [_c('editable-image', _vm._b({
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "attribute": "gif",
      "width": "400",
      "height": "400",
      "resizable": true
    }
  }, 'editable-image', _vm.$data, false))], 1) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "jobs"
  }, [_c('company-jobs', {
    attrs: {
      "company": _vm.company,
      "editable": _vm.editable
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "facts"
  }, [_c('company-facts', _vm._b({}, 'company-facts', {
    company: _vm.company,
    breakfastFoods: _vm.breakfastFoods,
    editable: _vm.editable
  }, false))], 1), _vm._v(" "), _c('template', {
    slot: "like"
  }, [_c('company-like', {
    attrs: {
      "company": _vm.company
    }
  })], 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d09d956","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/profile.vue
// module id = null
// module chunks = 